import { Auth, updatePassword } from "firebase/auth";
import { getFirebaseAuth } from "../../firebase/firebaseService";
import { FirestoreService } from "../../firebase/firestoreService";
import { resetPasswordRateLimiter } from "../../services/resetPasswordRateLimiter";
import {
  passwordResetFailure,
  passwordResetStart,
  passwordResetSuccess,
  resetAllStates,
  resetEmailSend,
  resetEmailSendFailure,
} from "../authSlice";
import type { AuthAppDispatch } from "../store";

export const resetPasswordViaEmail =
  (_firebaseAuth: Auth, email: string) => async (dispatch: AuthAppDispatch) => {
    dispatch(resetAllStates());
    try {
      await resetPasswordRateLimiter(email);
      dispatch(resetEmailSend());
    } catch (error) {
      if (error instanceof Error) {
        dispatch(resetEmailSendFailure(error.message));
      } else {
        dispatch(resetEmailSendFailure("An unknown error occurred."));
      }
    }
  };

export const resetPasswordInFirebase =
  (newPassword: string, uid: string) => async (dispatch: AuthAppDispatch) => {
    dispatch(passwordResetStart());
    try {
      const currentUser = getFirebaseAuth().currentUser;
      if (currentUser) {
        await updatePassword(currentUser, newPassword);
        await FirestoreService.updateDocument("providers", uid, {
          lastPasswordUpdatedOn: moment().toISOString(),
        });
        dispatch(passwordResetSuccess());
      }
    } catch (error) {
      if (error instanceof Error) {
        dispatch(passwordResetFailure(error.message));
      } else {
        dispatch(passwordResetFailure("An unknown error occurred."));
      }
    }
  };
